import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import User from 'flarum/common/models/User';
import Badge from 'flarum/common/components/Badge';

app.initializers.add('happydigital-icebreaker', () => {
  extend(User.prototype, 'badges', function (items) {
    const username = app.forum.attribute('icebreakerBadgeUsername');

    if (!username || this.username() !== username) return;

    items.add(
      'icebreaker',
      <Badge type="icebreaker" icon="fas fa-robot" label={app.translator.trans('happydigital-icebreaker.forum.badge_label')} />,
      100
    );
  });
});
